export default __webpack_public_path__ + "static/media/ALAPUZHA.f09a8e51.jpg";